import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  background-color: ", ";\n\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { css } from 'styled-components';
export var buttonBackgroundColorMixin = css(_templateObject(), function (_ref) {
  var disabled = _ref.disabled,
      inactive = _ref.inactive,
      disabledBackgroundColor = _ref.disabledBackgroundColor,
      backgroundColor = _ref.backgroundColor;
  return (
    /* prettier-ignore */
    disabled && !inactive ? disabledBackgroundColor : backgroundColor
  );
}, function (_ref2) {
  var inactive = _ref2.inactive,
      disabled = _ref2.disabled,
      $hasTouch = _ref2.$hasTouch,
      hoverBackgroundColor = _ref2.hoverBackgroundColor,
      focusBackgroundColor = _ref2.focusBackgroundColor;
  return !inactive && !disabled && !$hasTouch && "\n      &:hover {\n        " + (hoverBackgroundColor ? "background-color: " + hoverBackgroundColor + ";" : '') + "\n      }\n      &:focus {\n        " + (focusBackgroundColor ? "background-color: " + focusBackgroundColor + ";" : '') + "\n      }\n    ";
}, function (_ref3) {
  var inactive = _ref3.inactive,
      disabled = _ref3.disabled,
      activeBackgroundColor = _ref3.activeBackgroundColor;
  return !inactive && !disabled && "\n      &:active {\n        " + (activeBackgroundColor ? "background-color: " + activeBackgroundColor + ";" : '') + ";\n      }\n    ";
});
export var buttonBackgroundColorKeys = ['backgroundColor', 'activeBackgroundColor', 'hoverBackgroundColor', 'focusBackgroundColor', 'disabledBackgroundColor'];